module.exports = __webpack_public_path__ + "static/media/home-pc-card.a81f5ac1.png";